export default __webpack_public_path__ + "static/media/moto.30030fa4.png";